import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '@service/auth.service';
import { AccessType } from 'ops/common/models/access-settings';

@Component({
    selector: 'app-custom-page-right-buttons',
    templateUrl: './custom-page-right-buttons.component.html',
    styleUrls: ['./custom-page-right-buttons.component.scss'],
    standalone: false
})
export class CustomPageRightButtonsComponent {
    @Input() usersAccess;

    @Output() onShareButtonClick = new EventEmitter();
    @Output() onEditButtonClick = new EventEmitter();
    @Output() onDeleteButtonClick = new EventEmitter();

    constructor(
        private authService: AuthService
    ) {}

    onShareClick(e: MouseEvent) {
        this.onShareButtonClick.emit(e);
    }

    onEditClick(e: MouseEvent) {
        this.onEditButtonClick.emit(e);
    }

    onDeleteClick(e: MouseEvent) {
        this.onDeleteButtonClick.emit(e);
    }

    getCurrentUserAccessLevel() {
        const currentUserId = this.authService.getCurrentUserId();
        if(this.usersAccess?.length > 0) {
            for(const key in this.usersAccess) {
                if (this.usersAccess[key].roleId === currentUserId) {
                    return this.usersAccess[key].accessLevel;
                }
            }
        }
        return '';
    }

    shouldShowShareButton(): boolean {
        const accessLevel = this.getCurrentUserAccessLevel();
        return this.accessLevelIsOwner(accessLevel) || this.accessLevelIsEdit(accessLevel);
    }

    shouldShowEditButton(): boolean {
        const accessLevel = this.getCurrentUserAccessLevel();
        return this.accessLevelIsOwner(accessLevel) || this.accessLevelIsEdit(accessLevel);
    }

    shouldShowDeleteButton(): boolean {
        const accessLevel = this.getCurrentUserAccessLevel();
        return this.accessLevelIsOwner(accessLevel);
    }

    accessLevelIsOwner(accessLevel: AccessType) {
        return accessLevel === AccessType.Owner;
    }

    accessLevelIsEdit(accessLevel: AccessType) {
        return accessLevel === AccessType.Edit;
    }
}